<template>
    <div class="container-center">

        <div v-if="msgData.messageType != '227'">
            <div class="inviteInfo solid text-center">
                <p class="title" >{{msgData.msgTypeName}}</p>
                <p>发布时间：{{ msgData.sendTime }}</p>
            </div>
            <div class="inviteInfo dashed">
                <h5>消息内容</h5>
                <div v-if="!msgData.content" class="no-data-tip" ></div>
                <div v-else class="text" v-html="msgData.content"></div>
            </div>
        </div>

        <div v-else>
            <div class="inviteInfo solid text-center">
                <p class="title" >{{msgData.content}}</p>
                <p>发布时间：{{ msgData.sendTime }}</p>
            </div>
            <div class="inviteInfo dashed">
                <h5>消息内容</h5>
                <div class="text" v-html="msgData.expand.bodyContent"></div>
            </div>
            <div class="end-title">
                <div v-for="(item, index) in endTitles" :key="index">
                    {{ item }}   
                </div>
            </div>
        </div>
    </div><!--container-center-->
</template>

<script>
import banner from '@/assets/imgs/banner_invite.png'
import util from '@/util'


export default {
    name: "msg-info",
    data() {
        return {

            // 参数信息
            id: this.$route.params.id,

            // 基本信息
            msgData: {},
            endTitles: []
        }
    },
    computed: {

    },
    methods: {

    },
    mounted: function() {

        // 获取数据
        this.$http.post('rest/api/supplierHomepage/getMsgDetial', this.id).then((res)=>{
            if(res.data.result) {
                this.msgData = res.data.value;

                if (this.msgData.messageType == '227') {
                    this.endTitles = JSON.parse(res.data.value.expand.endText)
                }
            }
        })

    },
    created(){
        this.$root.navs = [{name:'我的消息',path:'/msgList'},{name:'消息详情',path:''}];
        this.$root.headImage.src = banner;
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';

a {color:var(--cMain);}

ul {padding: 0;margin:0;}
ul li {list-style:none;}

ul.invite-mng-list li {padding:8px 12px;font-size:14px;}
ul.invite-mng-list li:nth-child(odd) {background:#f8f8f8;}
ul.invite-mng-list li a {color:var(--cTxt1);text-decoration:none;}
ul.invite-mng-list li a:hover {color:var(--cMain);}

.inviteInfo {font-size: 14px;}
.inviteInfo.solid {height: 100px;border-bottom: 1px solid #E6E7E6;padding-top: 50px;}
.inviteInfo.solid > p {margin: 0 0 24px 0;color: #000;font-size: 14px;}
.inviteInfo.solid > p.title {font-size: 18px;font-weight: bold;}
.inviteInfo.dashed {padding-bottom: 10px;border-bottom: 1px dashed #E6E7E6;}

.inviteInfo h5 {color: #252525;font-size: 15px;margin: 16px 0;}
.inviteInfo h5::before {content: '';display: inline-block;width: 5px;height: 5px;background: var(--cMain);vertical-align: middle;margin: 0 10px;}
.inviteInfo .filelink a{display: block;margin: 10px 0;color: var(--blueColor);}

.inviteInfo .text {padding:20px;}

.end-title { text-align: right; font-size: 14px; font-weight: bold; padding: 10px; }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/home/MsgDetail.vue